import { MetaInfo } from './app'
import { OPERATION_METHOD } from './content'
import { PaginationPageSettings } from '~/shared/types/paginatedDataset'

export enum SEARCH_RESULT_TYPE {
  DOCUMENT = 'DOCUMENT',
  API = 'API',
  OPERATION = 'OPERATION',
  SCHEMA = 'SCHEMA',
}

export enum SEARCH_RESULT_CONTENT_TYPE {
  OAS2 = 'OAS2',
  OAS3 = 'OAS3',
  ASYNC_API = 'ASYNC_API',
  DOCUMENT = 'DOCUMENT',
  GRAPH_QL = 'GRAPH_QL',
  MCP = 'MCP',
  A2A = 'A2A',
  GRPC = 'GRPC',
}

export enum SEARCH_TAB_TYPE {
  ALL = 'All',
  DOCS = 'Docs',
  APIS = 'APIs',
  OPERATIONS = 'Operations',
  SCHEMAS = 'Schemas',
}

export interface SearchResult {
  resultType?: SEARCH_RESULT_TYPE,
  title: string,
  apiTitle?: string,
  schemaName?: string,
  schemaTitle?: string,
  schemaProperties?: string,
  href: string,
  description?: string,
  tag?: string,
  path?: string,
  operationId?: string,
  method?: OPERATION_METHOD,
  contentType?: SEARCH_RESULT_CONTENT_TYPE,
  product: {
    name: string,
    slug: string
  }
  summary?: string,
  snippet: SearchSnippet[],
  titleSnippet: SearchSnippet[],
  metaInfo: MetaInfo,
  parents?: string[],
  componentAnchorId?: string,
  asyncChannelName?: string,
  messageId?: string,
  serverId?: string,
  channelId?: string,
}

export interface SearchNoOfElements {
  documents?: number,
  apis?: number,
  operations?: number,
  schemas?: number,
}

export interface PaginatedSearchResults {
  page?: PaginationPageSettings,
  noOfElements: SearchNoOfElements,
  items: SearchResult[]
}

export interface SearchSnippet {
  text: string,
  highlight: boolean
}